function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 143.5,
  cy: 146,
  fill: "#3A77FF",
  fillRule: "nonzero",
  rx: 129.5,
  ry: 129
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 15,
  d: "M85 221.64C26.416 233.223 17 167 17 167"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFE8A9",
  fillRule: "nonzero",
  d: "M102 36.124L116.72 160l76.28-9.075-14.72-123.876.418-.049z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE32",
  fillRule: "nonzero",
  d: "M.123 48.645l102.06-12.117 14.78 124.134-102.06 12.118z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M21.335 129.67l38.554-17.722 11.885 25.782-38.554 17.722z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 15,
  d: "M120 225c46.48-2.608 57-81 57-81"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D3C81",
  fillRule: "nonzero",
  d: "M151 278H60s6.903-78 45.187-78C143.47 200 151 278 151 278z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 105,
  cy: 183.5,
  fill: "#FFF",
  fillRule: "nonzero",
  rx: 29,
  ry: 28.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D3C81",
  fillRule: "nonzero",
  d: "M130 168.535c-7.107-12.351-22.064-17.7-35.325-12.635-13.262 5.066-20.92 19.055-18.09 33.04.074.361.185.704.271 1.06a42.436 42.436 0 0014.186-18.531A41.806 41.806 0 00130 168.535z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117.5,
  cy: 181.5,
  r: 3.5,
  fill: "#002F34",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94.5,
  cy: 186.5,
  r: 3.5,
  fill: "#002F34",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94.5,
  cy: 145.5,
  r: 17.5,
  fill: "#1D3C81",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#002F34",
  d: "M177 140l-7 8m14-6l-7 8"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#002F34",
  strokeLinejoin: "bevel",
  strokeWidth: 2,
  d: "M31 130.994L46.662 142 56 102"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CEDDFF",
  fillRule: "nonzero",
  d: "M244.647 109h-67.294L171 102.671V6.329L177.353 0h58.523L251 15.324v87.347z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D3C81",
  fillRule: "nonzero",
  d: "M236 0v15h15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M251 66l-33 43h26.616l6.384-6.287z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D3C81",
  fillRule: "nonzero",
  d: "M187 38h47v5h-47zm0 8h47v5h-47zm0 9h47v5h-47z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#002F34",
  strokeLinejoin: "bevel",
  strokeWidth: 2,
  d: "M214 77.601L222.339 88 236 70"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCE32",
  fillRule: "nonzero",
  d: "M204.135 156.538l75.739 18.042-10.744 44.973-75.739-18.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M201 169l15-9.11-12.133-2.89zm-5.165 12L205 196l-12-2.912zM272 207l-15 9.11 12.133 2.89zm5.164-20L268 172l12 2.912z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8FB7FF",
  fillRule: "nonzero",
  d: "M247.359 237h-72.718L168 230.374v-55.748l6.641-6.626h72.718l6.641 6.626v55.748z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1D3C81",
  fillRule: "nonzero",
  d: "M160 193h32v18h-32z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 202,
  r: 4,
  fill: "#3A77FF",
  fillRule: "nonzero"
}));

const SvgPayShipSuccessPicture = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 280,
  height: 278
}, props), _ref);

export default SvgPayShipSuccessPicture;